<template>
  <v-layout justify-end>
    <!-- <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn> -->
    <v-dialog v-model="localDialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    label="Voice Type"
                    v-model="local.voiceType"
                    :rules="generalRules"
                    required
                  ></v-text-field>
                  <v-select
                    :items = "languages"
                    label = "Select Language"
                    v-model = "local.language"
                  ></v-select>
                  <v-select
                    :items = "voiceEffects"
                    label = "Select Voice Effect"
                    v-model = "local.voiceEffect"
                  ></v-select>
                  <v-textarea
                    label="Voice Text"
                    v-model="local.voiceText"
                  >
                  </v-textarea>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>

                <v-flex>
                  <v-text-field
                    v-model="local.voiceVolume"
                    label="Voice Volume"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.startTime"
                    label="Start Time"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.endTime"
                    label="End Time"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number"
                    min="0">
                  </v-text-field>
                  <h3>Type of Component</h3>
                  <v-radio-group v-model="local.componentType" row>
                    <v-radio :label="componentType.threeD" :value="componentType.threeD"></v-radio>
                    <v-radio :label="componentType.character" :value="componentType.character"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'

export default {
  name: 'addTts',
  components: { ImageUploader, FileUploader },
  data: () => ({
    valid: true,
    saving: false,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    languages: ['German', 'French', 'Spanish'],
    voiceEffects: [],
    url: '',
    checkUrl: null,
    componentType: {
      threeD: '3D',
      character: 'Character'
    },
    local: {
      id: null,
      voiceType: '',
      language: '',
      voiceEffect: '',
      voiceText: '',
      voiceVolume: '',
      startTime: '',
      endTime: '',
      duration: '',
      componentType: 'Character'
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    info: {
      id: null,
      name: '',
      filename: '',
      service: '',
      description: '',
      image: null
    }
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New TTS' : 'Edit TTS'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    open () {
      this.$emit('open')
    },
    close () {
      // console.log(`image: ${this.local.image.imageURL}`)
      // console.log(`imageFile: ${this.local.image.imageFile}`)
      this.$emit('close')
    },
    addURL () {
      let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      let objExp = new RegExp(Expression)
      if (objExp.test(this.url) === true) {
        this.checkUrl = true
        this.local.videoLink = this.url
        // this.url = ''
      } else {
        this.checkUrl = false
      }
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.image === null) {
        flag = false
        this.errorMsg = 'Please add a picture'
      }
      if (this.typeOfMedia === 'video') {
        if (this.local.Media === {} && this.local.videoLink === null) {
          flag = false
          this.errorMsg = 'Please add a video file or video link'
        }
      } else {
        if (this.local.Media === {}) {
          flag = false
          this.errorMsg = 'Please add a media file'
        }
      }
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    },
    assignFile (payload) {
      this.local.UI = payload
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addTts.vue